import { render, staticRenderFns } from "./HeaderLabels.vue?vue&type=template&id=afe8409c&scoped=true&"
import script from "./HeaderLabels.vue?vue&type=script&lang=js&"
export * from "./HeaderLabels.vue?vue&type=script&lang=js&"
import style0 from "./HeaderLabels.vue?vue&type=style&index=0&id=afe8409c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe8409c",
  null
  
)

export default component.exports